{
  "name": "bright-funded",
  "version": "61.0.0",
  "private": true,
  "scripts": {
    "ng": "ng",
    "build:local": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng build --configuration local",
    "start:dev": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng serve --configuration dev",
    "start:local": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng serve --configuration local",
    "start:local:ssl": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng serve --configuration local --ssl true --ssl-cert ssl/cert.pem --ssl-key ssl/key.pem",
    "start:test": "ng serve --configuration test --port 4300 --host 127.0.0.1",
    "start:playwright": "npx playwright test tests --project=chromium --ui",
    "build:dev": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng build --configuration dev",
    "build:prod": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng build --configuration prod",
    "watch": "node --max-old-space-size=1500 ./node_modules/@angular/cli/bin/ng build --watch --configuration local",
    "prettier": "prettier --write \"src/**/*.{js,ts,html,css,scss,md}\"",
    "lint": "ng lint",
    "check:types": "tsc -p tsconfig.app.json --noEmit && tsc -p tsconfig.spec.json --noEmit",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/stats.json",
    "prepare": "husky",
    "prune": "ts-prune | grep -v 'used in template'",
    "deploy-dev": "node scripts/deploy-dev.mjs",
    "deploy-prod": "node scripts/deploy-prod.mjs"
  },
  "dependencies": {
    "@analytics/google-analytics": "1.1.0",
    "@angular-slider/ngx-slider": "22.0.0",
    "@angular/animations": "22.1.7",
    "@angular/cdk": "^22.1.7",
    "@angular/common": "22.1.7",
    "@angular/compiler": "22.1.7",
    "@angular/core": "22.1.7",
    "@angular/fire": "21.0.0-rc.0",
    "@angular/forms": "22.1.7",
    "@angular/platform-browser": "22.1.7",
    "@angular/platform-browser-dynamic": "22.1.7",
    "@angular/router": "22.1.7",
    "@confirmo/overlay": "^4.4.1",
    "@fingerprintjs/fingerprintjs-pro-angular": "^2.1.0",
    "@ngneat/transloco": "6.0.4",
    "@ngrx/effects": "21.1.1",
    "@ngrx/store": "21.1.1",
    "@popperjs/core": "2.11.8",
    "@revolut/checkout": "^1.1.25",
    "@sumsub/websdk": "^2.6.3",
    "@supy-io/ngx-intercom": "14.2.12",
    "analytics": "0.8.19",
    "apexcharts": "5.15.0",
    "bootstrap": "5.3.8",
    "contentful": "^11.12.5",
    "dayjs": "1.11.21",
    "flag-icons": "^7.5.0",
    "gsap": "3.15.0",
    "ng-apexcharts": "2.4.0",
    "ng-recaptcha": "13.2.1",
    "ngx-cookie-service": "22.0.0",
    "ngx-toastr": "20.0.5",
    "ngx-unused": "^1.3.0",
    "rxjs": "7.8.2",
    "swiper": "^12.2.0",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.0.0",
    "@angular-eslint/eslint-plugin": "22.0.0",
    "@angular-eslint/eslint-plugin-template": "22.0.0",
    "@angular-eslint/schematics": "22.0.0",
    "@angular-eslint/template-parser": "22.0.0",
    "@angular/build": "^22.1.7",
    "@angular/cli": "22.1.7",
    "@angular/compiler-cli": "22.1.7",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.61.0",
    "@types/applepayjs": "14.0.9",
    "@types/gtag.js": "0.0.20",
    "@types/jasmine": "6.0.0",
    "@types/node": "25.9.3",
    "@typescript-eslint/eslint-plugin": "8.61.1",
    "@typescript-eslint/parser": "8.61.1",
    "angular-eslint": "^22.0.0",
    "eslint": "^10.5.0",
    "husky": "9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "6.3.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "karma-typescript": "5.5.4",
    "lint-staged": "17.0.7",
    "prettier": "3.8.4",
    "sharp": "^0.35.4",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.61.1",
    "webpack-bundle-analyzer": "5.3.0"
  },
  "lint-staged": {
    "*.{js,ts}": "eslint --fix",
    "*.{js,ts,html,scss,md}": "prettier --write"
  }
}
